"use client";
import React from "react";
import { Next13ProgressBar } from "next13-progressbar";

const Loader = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <Next13ProgressBar height="4px" color={"#959595"} showOnShallow />
      {children}
    </>
  );
};

export default Loader;
